import { FaExclamationTriangle } from 'react-icons/fa';
import { Button } from '@/components/UI';

interface BacktestDangerZoneProps {
    disabled: boolean;
    isBusy: boolean;
    onReset: () => void;
}

const BacktestDangerZone = ({ disabled, isBusy, onReset }: BacktestDangerZoneProps) => (
    <div className="mt-4 rounded-lg border border-red-800/60 bg-red-950/10 p-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="min-w-0">
                <div className="flex items-center gap-2 font-semibold text-red-300">
                    <FaExclamationTriangle aria-hidden="true" /> Danger zone
                </div>
                <p className="mt-1 text-sm text-zinc-400">
                    Delete eligible strategy backtests. Protected evidence and portfolio artifacts remain. Preview the counts before
                    confirming.
                </p>
            </div>
            <Button disabled={disabled || isBusy} isLoading={isBusy} variant="danger" onClick={onReset}>
                Reset backtests…
            </Button>
        </div>
    </div>
);

export default BacktestDangerZone;
